import React from "react";
import { Box } from "@mui/material";

const ThanksDecor = () => <Box component="img" src="/images/pages/thanks/hero-icon.svg"/>

export default ThanksDecor;
